import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./i18n";
import LoginPage from "./pages/login/LoginPage";
import AgentPage from "./pages/agent/AgentPage";
import ResetPasswordPage from "./pages/login/ResetPasswordPage";
import SetupPasswordPage from "./pages/login/SetupPasswordPage";
import ProtectedRoute from "./pages/agent/ProtectedRoute";
import Admin from "./pages/agent/agentSubPages/Admin";
import FuelRequests from "./pages/agent/agentSubPages/FuelRequests";
import FuelHistory from "./pages/agent/agentSubPages/FuelHistory";
import ChatInfo from "./pages/agent/agentSubPages/adminSubPages/ChatInfo";
import AgentInstitute from "./pages/agent/agentSubPages/AgentInstitute";
import ArticlePage from "./pages/agent/agentSubPages/insituteSubPages/ArticlePage";
import InstituteMainPage from "./pages/agent/agentSubPages/insituteSubPages/InstituteMainPage";
import ErrorPage from "./pages/ErrorPage";
import ReactGA from "react-ga4";
import AgentMainPage from "./pages/agent/agentSubPages/adminSubPages/AgentMainPage";

if (process.env.REACT_APP_VERSION === "NZT") {
  ReactGA.initialize(process.env.REACT_APP_NZT_GA_MEASUREMENT_ID);
}

export const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/setup-password",
    element: <SetupPasswordPage />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AgentPage />
      </ProtectedRoute>
    ),
    children: [
      {
        element: <Admin />,
        children: [
          { index: true, element: <AgentMainPage /> },
          { path: ":guid", element: <ChatInfo /> },
        ],
      },
      { path: "fuel_requests", element: <FuelRequests /> },
      { path: "fuel_history", element: <FuelHistory /> },
      {
        path: "institute",
        element: <AgentInstitute />,
        children: [
          { index: true, element: <InstituteMainPage /> },
          { path: ":title", element: <ArticlePage /> },
        ],
      },
    ],
  },
  { path: "/error", element: <ErrorPage /> },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>
);
